<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />

    <base-header>
      <div class="row align-items-center  pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteManyBranches()"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              type="primary"
              @click="openNewDestinationModal()"
              class="min-button"
              :disabled="destinationsOptions.length < 0"
            >
              <i class="flaticon-plus"></i> Assign
              <strong class="d-lg-block d-none ml-1"> New Destination</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 text-right align-self-center"
          >
            <div>
              <div class="box-buttons"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2 mt-3"
          ></div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
          >
            <div class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block">
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class=""
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    :aria-describedby="ariaDescribedby"
                    @change="applySortBy"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    :aria-describedby="ariaDescribedby"
                    @change="applySortType"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-1"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download([])">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>
            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div>
          <pagination-block
            :pageCount="responseBranch.pages"
            v-model="currentPage"
            :total="responseBranch.count"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="preventPaginations"
            position="bottom"
          ></pagination-block>

          <b-table
            hover
            :items="branches"
            :fields="fields"
            sort-by.sync="name"
            sort-asc.sync="true"
            selectable
            @row-selected="onRowSelected"
            select-mode="multi"
            ref="selectableTable"
            sort-icon-left
            responsive
            show-empty
            empty-filtered-text="There are no records matching your request"
            empty-text="There are no records to show"
            :stacked="cardview"
          >
            <template #head()="{ label, field: { key } }">
              <span v-if="key === 'selected'">
                <span
                  @click="clearSelected"
                  v-if="selectedRows.length == branches.length"
                  class="check-table selected"
                ></span>

                <span @click="selectAllRows" v-else class="check-table"></span>
              </span>
              <span v-else>{{ label }}</span>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true" class="check-table selected"></span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true" class="check-table"></span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template #cell(name)="data">
              <span class="role-table">{{
                data.item.destination.country.name
              }}</span>
              <span
                class="capitalize hide-data ml-0 font-weight-bold"
                style="color:var(--black)"
                @click.stop="openEditDestinationModal(data.item._id, data.item)"
                >{{ data.item.name }}
              </span>
            </template>

            <template #cell(radius)="data">
              <span class="hide-data">{{ data.item.selection_range }}</span>
            </template>

            <template #cell(areas)="data">
              <span class="hide-data">{{
                data.item.areasSummary.unaffiliated
              }}</span>
            </template>

            <template #cell(rates)="data">
              <span class="hide-data">{{
                data.item.ratesSummary.unaffiliated
              }}</span>
            </template>

            <template #cell(actions)="data">
              <el-tooltip content="Edit" placement="bottom">
                <span
                  class="icon-action text-blue"
                  @click.stop="
                    openEditDestinationModal(data.item._id, data.item)
                  "
                >
                  <i class="flaticon-pencil text-primary"></i>
                </span>
              </el-tooltip>

              <el-tooltip content="Coverage Areas" placement="bottom">
                <span
                  class="icon-action text-new ml-2"
                  @click="
                    $router.push(
                      `/destinations/${data.item._id}/coverage-areas`
                    )
                  "
                >
                  <i class="flaticon-radar"></i>
                </span>
              </el-tooltip>

              <el-tooltip content="Rates" placement="bottom">
                <span
                  class="icon-action text-warning ml-2"
                  @click="$router.push(`/destinations/${data.item._id}/rates`)"
                >
                  <i class="flaticon-bold-list"></i>
                </span>
              </el-tooltip>

              <el-tooltip content="Delete" placement="bottom">
                <span
                  class="icon-action text-danger ml-2"
                  @click="deleteBranch(data.item._id)"
                >
                  <i class="flaticon-delete"></i>
                </span>
              </el-tooltip>
            </template>
          </b-table>

          <pagination-block
            :pageCount="responseBranch.pages"
            v-model="currentPage"
            :total="responseBranch.count"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            position="bottom"
          ></pagination-block>
        </div>
      </div>

      <NewDestination
        :show="showNewDestinationModal"
        :destinations="destinationsOptions"
        :supplierId="supplierId"
        @close="closeNewDestinationModal"
      />
      <EditDestination
        :show="showEditDestinationModal"
        :branchId="tempBranchId"
        :branch="tempBranch"
        @close="closeEditDestinationModal"
      />
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import endpoint from "../../Commons/Services/index";
import Swal from "sweetalert2";
import moment from "moment";
import localHelper from "../Commons/Helper";
import NewDestination from "../Components/NewDestination.vue";
import EditDestination from "../Components/EditDestination.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import { goBack } from "../../../helpers/commons.helpers";
import { handleApiError } from "../../../core/services";
export default {
  name: "Destinations",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    NewDestination: NewDestination,
    EditDestination: EditDestination
  },
  data() {
    return {
      currentPage: 1,
      selectedRows: [],
      currentRow: null,
      loading: true,
      modal: false,
      limit: 0,
      query: "",
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "name",
          label: "Destination",
          sortable: true,
          thStyle: { minWidth: "200px" },
          class: "text-left"
        },

        {
          key: "radius",
          label: "Coverage Radius",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "alinmov6"
        },
        {
          key: "areas",
          label: "Coverage Areas",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "alinmov6"
        },
        {
          key: "rates",
          label: "Rates",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "alinmov6"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      simpleSearch: "",
      sortBy: "",
      sortDesc: "asc",
      sortOptions: [
        {
          value: "name",
          text: "Destination"
        },
        {
          value: "radius",
          text: "Coverage Radius"
        },
        {
          value: "areasSummaryUnaffiliated",
          text: "Coverage Areas"
        },
        {
          value: "ratesSummaryUnaffiliated",
          text: "Rates"
        },
        { value: "created_at", text: "Created At" }
      ],
      cardview: false,
      view: "table",
      showNewDestinationModal: false,
      destinationsOptions: [],
      tempBranchId: "",
      tempBranch: {},
      showEditDestinationModal: false,
      supplierId: "",
      visibleSideBar: false,
      guides: [],
      loader: false
    };
  },
  async created() {
    var bread = [
      {
        text: "Destinations",
        active: true
      }
    ];
    this.setItemsBread(bread);
    await this.getLimit();
    this.supplierId = this.getSupplierIdBySession(this.sesion);
    this.limit = this.paginationLimit;
    this.query = this.branchesSearchCriteria.query;
    this.currentPage = this.branchesSearchCriteria.currentPage;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
    this.destinationsOptions = await this.getDestinationsOptions();
    await this.getOperatorsSelections();
  },
  methods: {
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    preventPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    async deleteBranch(branchId) {
      let { value } = await Swal.fire({
        title: "Delete Destination",
        text: "Are you sure do you want to delete this Destination?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteBranchById(branchId);
      }
    },
    async deleteBranchById(branchId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.branches.services.deleteBranchById(
          branchId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(false, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Brach has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteManyBranches() {
      let { value } = await Swal.fire({
        title: "Delete Destinations",
        text: "Are you sure do you want to delete the selected Destinations?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyBranchesById(this.selectedRows);
      }
    },
    async deleteManyBranchesById(branches = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.branches.services.deleteManyBranchesById(
          { branches: branches },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(false, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Destinations has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(branches = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.exports.services.exportCSVBranches(
          this.supplierId,
          { branches: branches },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `branches-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    handleError(error, message) {
      handleApiError(this, error, message);
    },
    goToPreviousPage() {
      goBack(this);
    },
    applySimpleSearch(value) {
      this.query = this.addElementInQuery(this.query, "search", value);
      this.get(true, this.limit, 1, this.query);
    },
    get(loader, limit, page, query) {
      this.setBranchesSearchCriteria({
        currentPage: page,
        query: query,
        limit: limit,
        status: true
      });
      this.getBranches({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value.trim());
      } else {
        searchParams.append(key, value.trim());
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    openNewDestinationModal() {
      this.showNewDestinationModal = true;
    },
    closeNewDestinationModal(status) {
      this.showNewDestinationModal = false;
      if (status !== "close") {
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    openEditDestinationModal(branchId, branch) {
      this.tempBranchId = branchId;
      this.tempBranch = branch;
      this.showEditDestinationModal = true;
    },
    closeEditDestinationModal(status) {
      this.tempBranchId = "";
      this.tempBranch = {};
      this.showEditDestinationModal = false;
      if (status !== "close") {
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    async getDestinationsOptions() {
      try {
        let {
          data
        } = await endpoint.destinations.services.getDestinationsOptions(
          this.sesion.token
        );
        if (data.status) {
          let destinations = data.data || [];
          return this.sortByCityName(destinations);
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    sortByCityName(destinations = []) {
      return destinations.sort((a, b) => {
        const firstCity = a.city.toUpperCase();
        const secondCity = b.city.toUpperCase();
        if (firstCity < secondCity) {
          return -1;
        }
        if (firstCity > secondCity) {
          return 1;
        }
        return 0;
      });
    },
    getSupplierIdBySession(session) {
      return session.role === session.account_type.type
        ? session.id
        : session.account_type.owner;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("SUPPLIERS", "DESTINATIONS");
      this.loader = false;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await endpoint.documents.services.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapActions([
      "getBranches",
      "getOperatorsSelections",
      "getSesion",
      "getLimit"
    ]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setBranchesSearchCriteria"
    ])
  },
  computed: {
    branches: function() {
      if (this.responseBranch.docs) {
        return this.responseBranch.docs;
      } else {
        return [];
      }
    },
    ...mapGetters([
      "responseBranch",
      "sesion",
      "paginationLimit",
      "branchesSearchCriteria"
    ])
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInBranchesModule(
      to.meta.modules,
      this.setBranchesSearchCriteria,
      "destinations"
    );
    next();
  }
};
</script>
